module.exports = __webpack_public_path__ + "img/AE5004-01.0c3069c1.jpg";